export default function extractFirstName(name) {
  if (!name) return "User";
  return name.split(" ")[0] && name.split(" ")[0].length > 2
    ? name.split(" ")[0]
    : name;
}
